/* globals RTCSessionDescription */
'use strict';

module.exports = RTCSessionDescription; //# sourceMappingURL=firefox.js.map